import React from 'react';

const formatDate = (timestamp) => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

const formatTime = (timestamp, currentTime) => {
  if (!timestamp) return currentTime.toLocaleTimeString('en-GB', { hour12: false });
  const date = new Date(timestamp);
  return date.toLocaleTimeString('en-GB', { hour12: false });
};

const formatGPS = (gpsData) => {
  if (!gpsData) return 'N/A';
  if (typeof gpsData === 'string') return gpsData;
  if (gpsData.lat && gpsData.lng) {
    return `${gpsData.lat.toFixed(6)}, ${gpsData.lng.toFixed(6)}`;
  }
  return 'N/A';
};

const InfoRow = ({ icon, label, value, compact = false }) => (
  <div style={{
    display: 'flex',
    alignItems: 'flex-start',
    gap: compact ? '6px' : '8px',
    marginBottom: compact ? '6px' : '8px',
    fontSize: compact ? '11px' : '13px',
  }}>
    <span style={{ fontSize: compact ? '14px' : '16px', flexShrink: 0 }}>
      {icon}
    </span>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{
        color: '#666',
        fontSize: compact ? '9px' : '10px',
        textTransform: 'uppercase',
        fontWeight: '600',
        marginBottom: '2px',
      }}>
        {label}
      </div>
      <div style={{
        color: '#1a1a1a',
        fontWeight: '500',
        wordBreak: 'break-word',
        fontFamily: 'monospace',
      }}>
        {value || 'N/A'}
      </div>
    </div>
  </div>
);

export const MetadataPanel = ({ unitData, compact = false, currentTime }) => {
  if (!unitData) return null;

  const metadata = unitData.metadata || {};

  return (
    <div style={{
      padding: compact ? '10px' : '16px',
      backgroundColor: 'white',
      borderRadius: compact ? '8px' : '12px',
      border: '1px solid #e0e0e0',
      height: '100%',
      overflow: 'auto',
    }}>
      <div style={{
        fontSize: compact ? '13px' : '16px',
        fontWeight: '700',
        marginBottom: compact ? '10px' : '12px',
        color: '#1a1a1a',
        borderBottom: '2px solid #2196f3',
        paddingBottom: '8px',
      }}>
        Unit Information
      </div>

      <InfoRow
        icon="🚑"
        label="Unit Code"
        value={metadata.unitCode || metadata.name || unitData.unitId?.substring(0, 12)}
        compact={compact}
      />

      <InfoRow
        icon="👮"
        label="Officer Name"
        value={metadata.responderName || metadata.officerName || metadata.officer}
        compact={compact}
      />

      <InfoRow
        icon="📍"
        label="GPS Coordinates"
        value={formatGPS(metadata.gps) || metadata.location || metadata.coordinates}
        compact={compact}
      />

      <InfoRow
        icon="📅"
        label="Date"
        value={formatDate(metadata.timestamp || unitData.lastUpdate)}
        compact={compact}
      />

      <InfoRow
        icon="🕐"
        label="Time"
        value={formatTime(metadata.timestamp || unitData.lastUpdate, currentTime)}
        compact={compact}
      />

      <InfoRow
        icon="📶"
        label="Status"
        value={
          <span style={{
            color: unitData.stream ? '#4caf50' : '#f44336',
            fontWeight: '700'
          }}>
            {unitData.stream ? 'ONLINE' : 'OFFLINE'}
          </span>
        }
        compact={compact}
      />
    </div>
  );
};
